// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-article-jsx": () => import("./../src/pages/article.jsx" /* webpackChunkName: "component---src-pages-article-jsx" */),
  "component---src-pages-index-jsx": () => import("./../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-login-jsx": () => import("./../src/pages/login.jsx" /* webpackChunkName: "component---src-pages-login-jsx" */)
}

